import { SERVICE_ICONS } from "../../lib/site";
import { SectionHeading } from "./SectionHeading";

export const Services = ({ content }) => {
  const items = content.services || [];
  if (items.length === 0) return null;
  return (
    <section id="servicos" data-testid="services-section" className="py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-5 lg:px-10 grid lg:grid-cols-[1fr_1.6fr] gap-14">
        <SectionHeading eyebrow="Para sua estadia" title={content.services_title} intro={content.services_intro} />
        <div className="grid sm:grid-cols-2 gap-px bg-zinc-800/70 border border-zinc-800/70">
          {items.map((s) => {
            const { Icon } = SERVICE_ICONS[s.icon] || SERVICE_ICONS.star;
            return (
              <div key={s.id} data-testid={`service-card-${s.id}`} className="group bg-[#000000] p-7 sm:p-8 hover:bg-[#0A0A0A] transition-colors duration-500">
                <span className="h-12 w-12 grid place-items-center rounded-full border border-[#D4AF37]/40 text-[#D4AF37] group-hover:bg-[#D4AF37] group-hover:text-black transition-colors duration-500">
                  <Icon size={20} strokeWidth={1.5} />
                </span>
                <h3 className="font-display text-2xl mt-5 text-zinc-50">{s.title}</h3>
                {s.description && <p className="text-sm text-zinc-400 mt-2 leading-relaxed">{s.description}</p>}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
